import React from 'react';
import { demoPageContent } from './config/demoContent';
import Hero from './components/Hero';
import CategoryOverview from './components/CategoryOverview';
import DemoSection from './components/DemoSection';
import DueDiligence from './components/DueDiligence';
import FooterCTA from './components/FooterCTA';
import FullscreenToggle from './components/FullscreenToggle';
import FloatingContact from './components/FloatingContact';
import { FullscreenProvider } from './context/FullscreenContext';

function AppContent() {
  return (
    <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-blue-100 selection:text-blue-900">
      <nav className="border-b border-slate-100 bg-white/80 backdrop-blur-md sticky top-0 z-50 no-print">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-slate-900 rounded-lg flex items-center justify-center">
              <div className="w-4 h-4 border-2 border-white rounded-sm"></div>
            </div>
            <div className="font-bold text-lg tracking-tight text-slate-900">BPA Solutions</div>
          </div>
          <div className="flex items-center gap-4 sm:gap-6">
            <div className="hidden sm:flex items-center gap-6">
              <a href="#demos" className="text-sm font-medium text-slate-500 hover:text-slate-900 transition-colors">Solutions</a>
              <a href="#enquiry-form" className="text-sm font-medium text-slate-500 hover:text-slate-900 transition-colors">Contact</a>
            </div>
            <div className="w-px h-4 bg-slate-200 hidden sm:block"></div>
            <div className="flex items-center gap-3">
              <FullscreenToggle />
              <div className="hidden xs:block text-xs font-bold text-blue-600 uppercase tracking-widest">Demo Hub</div>
            </div>
          </div>
        </div>
      </nav>
      <main>
        <Hero content={demoPageContent.hero} />
        <CategoryOverview categories={demoPageContent.categories} />
        <DemoSection />
        <DueDiligence content={demoPageContent.dueDiligence} />
        <FooterCTA content={demoPageContent.closingCTA} />
      </main>
      <footer className="py-12 bg-slate-50 border-t border-slate-200 no-print">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <p className="text-sm text-slate-400">
            &copy;{new Date().getFullYear()} BPA Solutions. All rights reserved.
          </p>
          <p className="text-[10px] text-slate-300 mt-2 tracking-widest uppercase">
            Built for Transparency and Performance
          </p>
        </div>
      </footer>
      <FloatingContact />
    </div>
  );
}

function App() {
  return (
    <FullscreenProvider>
      <AppContent />
    </FullscreenProvider>
  );
}

export default App;